
export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage:
            'url(https://public.readdy.ai/ai/img_res/908aee48dab93d47b044fd5c9157261f.jpg)',
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/60"></div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-32 text-center">
        <div className="inline-block mb-6 px-4 py-2 bg-orange-600/90 rounded-full">
          <span className="text-white text-sm font-semibold">
            ⚠️ ATTENTION: Digital Transformation Starts Here
          </span>
        </div>

        <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight">
          Dominate Your Market with
          <br />
          <span className="text-orange-400">Digital Excellence</span>
        </h1>

        <p className="text-lg md:text-xl text-white/90 mb-8 max-w-3xl mx-auto leading-relaxed">
          Transform your business with cutting-edge digital marketing solutions, SEO strategies, and
          technology services that deliver real results. Based in Las Vegas, serving businesses
          nationwide.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <a
            href="mailto:domination@thompsondigital.org"
            className="px-8 py-4 bg-orange-600 text-white text-base font-semibold rounded-lg hover:bg-orange-700 transition-all transform hover:scale-105 shadow-lg whitespace-nowrap"
          >
            Get Started Today
          </a>
          <a
            href="tel:+17252756972"
            className="px-8 py-4 bg-white text-gray-900 text-base font-semibold rounded-lg hover:bg-gray-100 transition-all transform hover:scale-105 shadow-lg whitespace-nowrap"
          >
            Call Us: (725) 275-6972
          </a>
        </div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto">
          <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6 border border-white/20">
            <div className="text-3xl font-bold text-orange-400 mb-2">500+</div>
            <div className="text-white text-sm">Projects Completed</div>
          </div>
          <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6 border border-white/20">
            <div className="text-3xl font-bold text-orange-400 mb-2">98%</div>
            <div className="text-white text-sm">Client Satisfaction</div>
          </div>
          <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6 border border-white/20">
            <div className="text-3xl font-bold text-orange-400 mb-2">24/7</div>
            <div className="text-white text-sm">Support Available</div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white text-3xl"></i>
      </div>
    </section>
  );
}
